export default {
    add: {
        title: 'Ajouter une nouvelle entreprise',
    },
    analytics: {
        title: 'Analytiques',
    },
    businessDetails: {
        adminView: 'Vue admin',
        allBusinesses: 'Toutes les entreprises',
        editBusiness: "Modifier l'entreprise",
        disable: 'Désactiver',
        addBusiness: '+ Ajouter une entreprise',
        memberSince: 'Membre depuis {{date}}',
        openToVisits: 'Ouvert aux visites',
        daysAWeek_one: '{{count}} jour par semaine',
        daysAWeek_other: '{{count}} jours par semaine',
        photosCount_one: '{{count}} photo',
        photosCount_other: '{{count}} photos',
        description: 'Description',
        photos: 'Photos',
        firstOneIsTheCover: 'la première est la couverture',
        cover: 'Couverture',
        contact: 'Contact',
        contactPerson: 'Personne-ressource',
        email: 'Courriel',
        phone: 'Téléphone',
        website: 'Site web',
        instagram: 'Instagram',
        address: 'Adresse',
        offerNumber: 'OFFRE #{{number}}',
        storiesCount_one: '{{count}} story',
        storiesCount_other: '{{count}} stories',
        reelsCount_one: '{{count}} reel',
        reelsCount_other: '{{count}} reels',
        followersRequired: '{{count}} abonnés',
        closedToVisits: 'Fermé aux visites',
        noOffers: 'Aucune offre pour le moment',
        noAvailability: 'Aucune disponibilité définie',
    },
    businessInReview: {
        title: "Entreprise en cours d'examen",
        message: "Votre entreprise est actuellement en cours d'examen. Veuillez revenir plus tard pour des mises à jour.",
    },
    businessName: "Nom de l'entreprise",
    editBusiness: {
        editing: 'MODIFICATION',
        unsavedChanges: 'Modifications non enregistrées',
        saveChanges: 'Enregistrer',
        cancel: 'Annuler',
        fixErrors: "Veuillez corriger les erreurs avant d'enregistrer",
        validationErrorTitle: 'Certains détails doivent être corrigés',
        validationErrorDescription: 'Corrigez les champs ci-dessous, puis enregistrez à nouveau.',
        invalidField: 'Quelque chose ici doit être corrigé — ouvrez cette étape pour voir quoi',
        fields: {
            name: 'Nom de l’entreprise',
            description: 'Description',
            place: 'Adresse',
            categories: 'Catégorie',
            photos: 'Photos',
            offers: 'Offres',
            businessHours: 'Disponibilité',
            contactPerson: 'Personne-ressource',
            email: 'Courriel',
            phone: 'Téléphone',
        },
        addPhoto: 'Ajouter une photo',
        addPhotoTitle: 'Ajouter des photos',
        removePhoto: 'Retirer la photo',
        onSuccessAddPhoto: {
            title: 'Photos ajoutées',
            message: 'Vos photos ont été téléversées avec succès.',
        },
        onSuccessDeletePhoto: {
            title: 'Photo supprimée',
            message: 'La photo a été supprimée avec succès.',
        },
        switchLocaleHint: 'Passez à {{locale}} pour modifier la version {{language}} — les deux sont requises.',
        english: 'anglaise',
        french: 'française',
        whatTheyGet: 'Ce qu’ils obtiennent',
        offerDescription: 'Description (facultatif)',
        offerDescriptionHint: 'Ce qu’un influenceur devrait savoir avant de réclamer : conditions, ce qui n’est pas inclus, comment en profiter.',
        influencerSize: 'Taille de l’influenceur',
        storiesTheyPost: 'Stories publiées',
        reelsTheyPost: 'Reels publiés',
        addAnotherTier: '+ Ajouter un palier',
        removeOffer: 'Retirer l’offre',
        bothLanguagesRequired: 'L’anglais et le français sont requis.',
        custom: 'Personnalisé',
        customFollowerCount: 'Nombre d’abonnés personnalisé',
        followersMinimum: 'abonnés minimum',
    },
    finishSetup: 'Finaliser la configuration',
    home: {
        title: 'Accueil',
        callout: 'Contactez notre équipe pour modifier vos offres disponibles, vos heures d’ouverture ou vos photos de couverture',
        businessDetails: "Détails de l'entreprise",
        offers: 'Offres',
        messages: 'Messages',
    },
    newInfluencerRequest: 'Nouvelle demande d’influenceur',
    newInfluencerRequests: "Nouvelles demandes d'influenceurs",
    noNewRequestsForTheMoment: 'Aucune nouvelle demande pour le moment',
    onboarding: {
        noAccount: "Aucun compte professionnel n'est connecté à cet Instagram. Assurez-vous d'avoir les configurations appropriées",
        comeBackLater: 'Revenez plus tard !',
        selectAccount: {
            title: 'Sélectionner le compte Instagram',
        },
        setupProfile: {
            title: 'Configurer votre profil',
            cta: 'Créer un compte professionnel',
        },
        confirm: {
            title: "Bienvenue à l'expérience INVI !",
            message: "Un membre de l'équipe vous contactera sous peu pour compléter vos informations et activer votre compte.",
        },
    },
    profilesNeedAttention: "Profils en besoin d'attention",
    searchBy: 'Rechercher par nom, ville ou catégorie',
    settings: {
        title: 'Paramètres',
    },
    status: {
        approved: 'Approuvé',
        pending: 'En attente',
        deleted: 'Supprimé',
        draft: 'Brouillon',
    },
    businessOnboarding: {
        business: 'BUSINESS',
        welcome: {
            title: 'Bienvenue sur INVI',
            subtitle: 'Rejoignez une communauté d’influenceurs et faites rayonner votre entreprise.',
            headline:
                'Rejoignez une communauté d’<highlight>influenceurs</highlight> et faites <highlight>rayonner</highlight> <highlight>votre entreprise.</highlight>',
            highlights: {
                visibility: 'Plus de visibilité',
                collaborations: 'Des collaborations simples',
                community: 'Une communauté engagée',
            },
            tagline: 'Des collaborations qui ont du sens',
        },
        steps: {
            contact_and_address: 'Contact',
            category: 'Catégorie',
            description: 'Description',
            photos: 'Photos',
            your_offers: 'Offres',
            availabilities: 'Disponibilités',
        },
        titles: {
            contact_and_address: {
                title: 'Commencez avec l’essentiel',
                subtitle: 'Ajoutez vos informations de contact pour que les créateurs puissent vous trouver facilement.',
            },
            category: {
                title: 'Catégorie',
                subtitle: 'Sélectionnez la ou les catégories qui décrivent le mieux votre entreprise.',
            },
            description: {
                title: 'Décrivez votre établissement',
                subtitle: 'Parlez-nous de votre entreprise et de ce qui la rend unique.',
            },
            photos: {
                title: 'Photos',
                subtitle: 'Ajoutez des photos de votre établissement. La première photo sera la photo principale.',
            },
            your_offers: {
                title: 'Offres',
                subtitle: 'Veuillez configurer votre première offre pour les influenceurs.',
            },
            availabilities: {
                title: 'Disponibilités',
                subtitle: 'Indiquez les jours où votre établissement est ouvert aux collaborations.',
            },
        },
        contact: {
            cardTitle: 'Commençons par les bases',
            cardSubtitle: 'Cela prend moins d’une minute. Vous pourrez tout modifier plus tard.',
            name: { label: 'Nom de l’établissement', placeholder: 'Ex. Café Olimpico' },
            email: { label: 'Adresse courriel', placeholder: 'contact@cafeolimpico.com' },
            phone: { label: 'Numéro de téléphone', placeholder: '514 555-5555' },
            website: { label: 'Site web', placeholder: 'https://www.votresiteweb.com' },
            instagram: { label: 'Instagram', placeholder: '@votrecompteinstagram' },
            address: {
                label: 'Adresse principale',
                placeholder: 'Ex. 123 Rue Saint-Laurent, Montréal, QC',
                hint: 'C’est ici que votre établissement sera affiché pour les créateurs.',
            },
        },
        category: {
            cardTitle: 'Catégorie',
            subtitle: 'Sélectionnez la ou les catégories qui décrivent le mieux votre entreprise.',
        },
        description: {
            label: 'Présentation de votre établissement',
            placeholder:
                'Décrivez votre établissement, votre concept, l’ambiance, les expériences proposées, les services offerts et ce qui vous distingue de la concurrence.',
            topics: {
                ambiance: 'Ambiance',
                concept: 'Concept',
                services: 'Services',
                experience: 'Expérience client',
                strengths: 'Points forts',
            },
        },
        photos: {
            cardTitle: 'Photos',
            cardSubtitle: 'Ajoutez des photos de votre établissement. La première photo sera la photo principale.',
            add: 'Ajouter des photos',
            formats: 'JPG, PNG (max 10 Mo)',
            main: 'Photo principale',
        },
        offers: {
            offer: 'Offre',
            category: 'Catégorie de l’offre',
            influencerSize: 'Taille d’influenceur',
            requestedContent: 'Contenu demandé',
            story: 'Story',
            reel: 'Reel',
            reward: { label: 'Offre de collaboration', placeholder: 'Ex. Repas gratuit pour 2 personnes' },
            description: {
                label: 'Description de l’offre',
                optional: 'facultatif',
                placeholder: 'Ajouter des détails, conditions, exclusions, etc.',
            },
            add: 'Ajouter',
        },
        availabilities: {
            intro: 'Indiquez les jours où votre établissement est ouvert aux collaborations.',
            closed: 'Fermé aux visites',
            opening: 'ouverture',
            closing: 'fermeture',
        },
        done: {
            stepLabel: 'Finalisation',
            title: 'Votre établissement est prêt !',
            thanks: 'Merci de vous joindre à INVI.',
            next: 'Nous allons maintenant vérifier vos informations. Vous recevrez une confirmation par courriel sous peu.',
            backToDashboard: 'Retour au tableau de bord',
        },
        stepper: {
            copyTo: 'Copier vers {{language}}',
        },
    },
    unfinishedProfiles: 'Profils non terminés',
    viewSubmission: 'Voir la requête',
    yourBusiness: 'Votre entreprise',
};
